import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { 
  BarChart3,
  Users,
  Server,
  BookOpen,
  Shield,
  Brain
} from 'lucide-react';

const FeatureGrid = () => {
  const features = [
    {
      icon: BarChart3,
      title: 'Business Intelligence',
      description: 'Advanced analytics and reporting for data-driven decisions',
      color: 'text-blue-500'
    },
    {
      icon: Users,
      title: 'Team Collaboration',
      description: 'Seamless communication and project management tools',
      color: 'text-green-500'
    },
    {
      icon: Server,
      title: 'Tech Infrastructure',
      description: 'Robust development and deployment monitoring',
      color: 'text-purple-500'
    },
    {
      icon: BookOpen,
      title: 'Knowledge Hub',
      description: 'Centralized documentation and learning resources',
      color: 'text-orange-500'
    },
    {
      icon: Shield,
      title: 'Security First',
      description: 'Enterprise-grade security and compliance features',
      color: 'text-red-500'
    },
    {
      icon: Brain,
      title: 'AI Co-Pilot',
      description: 'Intelligent assistance for complex business queries',
      color: 'text-indigo-500'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-foreground mb-2">
          What's Coming
        </h2>
        <p className="text-muted-foreground">
          A comprehensive suite of tools designed to revolutionize your business operations
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <Card 
              key={feature.title}
              className="group hover:shadow-lg transition-all duration-300 ease-in-out hover:scale-105 border-border/50 hover:border-primary/20"
              style={{
                animationDelay: `${index * 100}ms`,
                animation: 'fadeInUp 0.6s ease-out forwards'
              }}
            >
              <CardHeader className="pb-3">
                <div className="flex items-center space-x-3">
                  <div className={`p-2 rounded-lg bg-muted/50 group-hover:bg-primary/10 transition-colors duration-300`}>
                    <Icon className={`h-6 w-6 ${feature.color} group-hover:scale-110 transition-transform duration-300`} />
                  </div>
                  <CardTitle className="text-lg">{feature.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-sm leading-relaxed">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureGrid;
